import React, { useEffect, useState } from "react";
import "./Hero.css";

const NODE_COUNT = 14;
const COLORS = ["#1976D2", "#00E676", "#7C4DFF", "#B0BEC5"];

function randomBetween(a, b) {
  return a + Math.random() * (b - a);
}

function createNodes() {
  return Array.from({ length: NODE_COUNT }).map((_, i) => ({
    id: i,
    x: randomBetween(60, 340),
    y: randomBetween(40, 160),
    r: randomBetween(4, 9),
    color: COLORS[i % COLORS.length],
    dx: randomBetween(-0.18, 0.18),
    dy: randomBetween(-0.18, 0.18),
    minX: randomBetween(40, 100),
    maxX: randomBetween(300, 340),
    minY: randomBetween(30, 70),
    maxY: randomBetween(130, 170)
  }));
}

export default function Hero({ t }) {
  const [nodes, setNodes] = useState(createNodes());

  useEffect(() => {
    let animationFrame;
    function animate() {
      setNodes(prev =>
        prev.map(node => {
          let nx = node.x + node.dx;
          let ny = node.y + node.dy;
          let dx = node.dx, dy = node.dy;
          if (nx < node.minX || nx > node.maxX) dx = -dx * randomBetween(0.85, 1.1);
          if (ny < node.minY || ny > node.maxY) dy = -dy * randomBetween(0.85, 1.1);
          dx += randomBetween(-0.01, 0.01);
          dy += randomBetween(-0.01, 0.01);
          dx = Math.max(-0.22, Math.min(0.22, dx));
          dy = Math.max(-0.22, Math.min(0.22, dy));
          return { ...node, x: nx, y: ny, dx, dy };
        })
      );
      animationFrame = requestAnimationFrame(animate);
    }
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  // Ενώνουμε κάθε node με τα 2-3 κοντινότερα
  const lines = [];
  nodes.forEach((a, i) => {
    const distances = nodes
      .map((b, j) => ({
        idx: j,
        dist: Math.hypot(a.x - b.x, a.y - b.y)
      }))
      .filter(b => b.idx !== i)
      .sort((a, b) => a.dist - b.dist)
      .slice(0, 3);
    distances.forEach(({ idx }) => {
      if (i < idx) lines.push([a, nodes[idx]]);
    });
  });

  return (
    <section className="hero-section" aria-label="Hero">
      <svg className="hero-bg" width="100%" height="100%" viewBox="0 0 400 200" aria-hidden="true">
        {lines.map(([a, b], idx) => (
          <line
            key={idx}
            x1={a.x}
            y1={a.y}
            x2={b.x}
            y2={b.y}
            stroke="#7C4DFF"
            strokeWidth="1.5"
            opacity="0.25"
          />
        ))}
        {nodes.map((node, i) => (
          <circle
            key={i}
            cx={node.x}
            cy={node.y}
            r={node.r}
            fill={node.color}
            stroke="#fff"
            strokeWidth="1.5"
            opacity="0.85"
          />
        ))}
      </svg>
      <div className="hero-content">
        <p className="hero-brand">KLEOS AI</p>
        <h1 className="hero-title">{t.hero_title}</h1>
        <p className="hero-tagline">{t.hero_tagline}</p>
        <div className="hero-actions">
          <a
            href="#contact"
            className="hero-cta-btn"
            aria-label={t.hero_cta_btn}
          >
            {t.hero_cta_btn}
          </a>
          <a
            href="#services"
            className="hero-btn"
            aria-label={t.hero_btn}
          >
            {t.hero_btn}
          </a>
        </div>
      </div>
      <div className="hero-scroll-hint" aria-hidden="true">
        <span />
      </div>
    </section>
  );
}
